/**
 * Strongly typed version of `Object.keys`.
 *
 * @template T - The object type.
 * @param obj - The object whose enumerable property names are to be returned.
 * @returns An array of the keys of the given object, typed as `keyof T` instead of just `string`.
 *
 * @example
 * type Locale = "en" | "no";
 * const allLocales: Record<Locale, string> = {
 *   en: "English",
 *   no: "Norsk",
 * };
 *
 * const localeKeys = keys(allLocales);
 * // type: ("en" | "no")[]
 * // value: ["en", "no"]
 */

export const keys = <T extends Record<string, unknown>>(obj: T): (keyof T)[] =>
  Object.keys(obj);
